export default "__VITE_ASSET__dd690549__"